/**
 * @generated SignedSource<<34885bc2641879165f4a5bdf048e6cf0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SearchBarRepositoryFragment$data = {
  readonly isOwnerEnterpriseManaged: boolean | null | undefined;
  readonly " $fragmentType": "SearchBarRepositoryFragment";
};
export type SearchBarRepositoryFragment$key = {
  readonly " $data"?: SearchBarRepositoryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"SearchBarRepositoryFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SearchBarRepositoryFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isOwnerEnterpriseManaged",
      "storageKey": null
    }
  ],
  "type": "Repository",
  "abstractKey": null
};

(node as any).hash = "b728e92edb142e5b9e3a33c061046fb0";

export default node;
